import React from 'react';
import '../css/components/CTAButtons.css';

const CTAButtons = () => {
  const handleCall = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.open('tel:+918287133175', '_self');
  };

  const handleEmail = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const email = 'samapawsampatti@gmail.com';
    const subject = 'Wealth Management Inquiry';
    const body = 'Hello,\n\nI am interested in your wealth management services. Please contact me to discuss how you can help me achieve my financial goals.\n\nThank you,';
    
    // Create a properly encoded mailto URL
    const mailtoUrl = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    try {
      window.location.href = mailtoUrl;
      
      // Check if email client actually opened by detecting if page loses focus
      setTimeout(() => {
        if (document.hasFocus()) {
          // Show fallback options
          const userChoice = window.confirm(
            `It looks like you don't have an email client set up.\n\n` +
            `Would you like to:\n` +
            `• Click "OK" to copy our email address\n` +
            `• Click "Cancel" to open Gmail in a new tab`
          );
          
          if (userChoice) {
            // Copy email to clipboard
            navigator.clipboard.writeText(email).then(() => {
              window.alert(`Email address copied to clipboard: ${email}\n\nSubject: ${subject}`);
            }).catch(() => {
              window.alert(`Please email us at: ${email}\nSubject: ${subject}`);
            });
          } else {
            // Open Gmail compose
            const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
            window.open(gmailUrl, '_blank');
          }
        }
      }, 1500);
      
    } catch (error) {
      window.alert(`Please email us at: ${email}\nSubject: ${subject}`);
    }
  };

  return (
    <div className="cta-buttons">
      <button 
        type="button"
        className="btn btn-primary"
        onClick={handleCall}
      >
        <i className="fas fa-phone"></i>
        Call Now
      </button>
      <button 
        type="button"
        className="btn btn-outline"
        onClick={handleEmail}
      >
        <i className="fas fa-envelope"></i>
        Send Email
      </button>
    </div>
  );
};

export default CTAButtons;